import everestLogo from "@/assets/logos/everest.svg";

const LogoPage = () => {
  return (
    <div className="logo-page h-screen flex justify-center items-center">
      <img alt="Everest" width="40%" height="auto" src={everestLogo}  />
    </div>
  );
};
export default LogoPage;
